export const FETCH_RESOURCE_REQUEST = 'FETCH_RESOURCE_REQUEST';
export const FETCH_RESOURCE_SUCCESS = 'FETCH_RESOURCE_SUCCESS';
export const FETCH_RESOURCE_ERROR = 'FETCH_RESOURCE_ERROR';

export const UPDATE_RESOURCE_PASSWORD_REQUEST =
  'UPDATE_RESOURCE_PASSWORD_REQUEST';
export const UPDATE_RESOURCE_REQUEST = 'UPDATE_RESOURCE_REQUEST';
export const UPDATE_RESOURCE_SUCCESS = 'UPDATE_RESOURCE_SUCCESS';
export const UPDATE_RESOURCE_ERROR = 'UPDATE_RESOURCE_ERROR';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const TOGGLE_RESOURCE_MEETING_MODAL = 'TOGGLE_RESOURCE_MEETING_MODAL';
